export function parseInitialPaymentAmount(initialAmount) {
  const parsed = initialAmount != null && initialAmount !== '' ? Number(initialAmount) : NaN;
  if (Number.isNaN(parsed) || parsed <= 0) return '';
  return String(parsed);
}

function getExchangeRate(fromCurrency, toCurrency, exchangeRates = []) {
  if (!fromCurrency || !toCurrency || fromCurrency === toCurrency) return 1;
  const direct = exchangeRates.find(
    (r) => r.fromCurrency === fromCurrency && r.toCurrency === toCurrency,
  );
  if (direct && Number.isFinite(direct.rate) && direct.rate > 0) return direct.rate;
  const inverse = exchangeRates.find(
    (r) => r.fromCurrency === toCurrency && r.toCurrency === fromCurrency,
  );
  if (inverse && Number.isFinite(inverse.rate) && inverse.rate > 0) return 1 / inverse.rate;
  return null;
}

export function paymentAmountInCheckCurrency(amount, paymentCurrency, checkCurrency, exchangeRates) {
  if (!Number.isFinite(amount) || amount <= 0) return null;
  if (!checkCurrency || paymentCurrency === checkCurrency) return amount;
  const rate = getExchangeRate(paymentCurrency, checkCurrency, exchangeRates);
  if (!Number.isFinite(rate) || rate <= 0) return null;
  return Math.round(amount * rate * 100) / 100;
}

/**
 * @param {string} amountStr
 * @param {object} [options]
 * @param {number} [options.maxAmount] — cap in check currency; skipped when <= 0
 * @param {string} [options.paymentCurrency]
 * @param {string} [options.checkCurrency]
 * @param {Array} [options.exchangeRates]
 */
export function validatePaymentAmount(amountStr, options = {}) {
  const parsed = parseFloat(amountStr);
  if (Number.isNaN(parsed) || parsed <= 0) {
    return { valid: false, amount: null, exceedsMax: false };
  }

  const { maxAmount, paymentCurrency, checkCurrency, exchangeRates } = options;
  if (maxAmount != null && maxAmount > 0 && checkCurrency) {
    const inCheckCurrency = paymentAmountInCheckCurrency(
      parsed,
      paymentCurrency || checkCurrency,
      checkCurrency,
      exchangeRates || [],
    );
    if (inCheckCurrency == null) {
      return { valid: false, amount: null, exceedsMax: false, missingRate: true };
    }
    if (inCheckCurrency > maxAmount + 0.001) {
      return { valid: false, amount: parsed, exceedsMax: true, maxAmount };
    }
  }

  return { valid: true, amount: parsed, exceedsMax: false };
}
